import styled from "styled-components";

export const FormContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

export const FormHeader = styled.h2`
  text-align: center;
  color: #333;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

  label {
    font-weight: bold;
    margin-bottom: 5px;
    color: #555;
  }

  input, select {
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  color: white;
  background-color: #2f2f2f;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #1a1a1a;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const Message = styled.p`
  text-align: center;
  font-weight: bold;
  color: ${({ isError }) => (isError ? "#1a1a1a" : "#595959")};
`;

export const ValidationError = styled.span`
  color: #1a1a1a;
  font-size: 14px;
  margin-top: 5px;
`;
